import template from './sidebar-footer.html';

export default angular
  .module('doxy.common.components.sidebarBottom', [])
  .component('sidebarFooter', {
    template,
    controller: function (
      $timeout,
      $scope,
      globalUi,
      preCallLauncher,
      trackingFactory
    ) {
      this.ui = globalUi.ui;

      this.preCallTest = function (e) {
        trackingFactory.global.trackButtonClick({
          context: null,
          button_action: 'opens pre-call test',
          button_text: 'pre-call test',
          button_type: 'button',
        });
        preCallLauncher.preCallTest(e);
      };
    },
  }).name;
